import {
  PTP_ANNOUNCEMENT_INTERVAL,
  PTP_DELAY_MECHANISM,
  PTP_SYNC_INTERVAL,
} from 'src/js/pages/settings/datetime/date-and-time-view-model';

export const settings = {
  settings: {
    personality: {
      '2110': 'ST 2110',
    },
    status: {
      title: 'System',
    },
    system: {
      title: 'System',
      button: {
        locate: 'LOCATE',
        reboot: 'REBOOT',
        snapshot: 'SNAPSHOT',
      },
      section: {
        deviceName: {
          deviceName: 'Device Name',
        },
        deviceStatus: {
          bootVersion: 'Boot Version',
          cardStatus: 'Card Status',
          cardType: 'Card Type',
          chipsetLoad: 'Encoding Chipset Load',
          cpldVersion: 'CPLD Version',
          firmwareDate: 'Firmware Date',
          firmwareVersion: 'Firmware Version',
          hardwareCompatibility: 'Hardware Compatibility',
          hardwareVersion: 'Hardware Version',
          partNumber: 'Part Number',
          personality: 'Personality',
          personalityReboot: 'Requires a reboot',
          serialNumber: 'Serial Number',
          systemUptime: 'System Uptime',
          temperature: 'Temperature',
          title: 'General',
        },
        userSettings: {
          title: 'User Preferences',
          brightness: 'Brightness',
          contrast: 'Contrast',
          clearStorage: 'Stored Preferences',
          clearStorageSuccess: 'Stored user preferences cleared',
        },
      },
      locateModal: {
        validation: 'Duration must be between 1 and 60',
        notStarted: {
          title: 'Device Locator',
          body1: 'Blink encoder LED for',
          body2: 'minutes.',
        },
        started: {
          title: 'Device Locator',
          body: 'Blinking of encoder LED will stop in {{time}}.',
        },
      },
      notifications: {
        updateSuccessMsg: 'System settings updated',
        updateErrorMsg: 'System settings could not be updated',
      },
    },
    upgrade: {
      title: 'Update',
      section: {
        currentVersion: {
          currentVersion: 'Current Version',
          packageToInstall: '{{fileName}} is pending installation. Reboot to install, or',
          packageToInstallCancel: 'cancel update',
        },
      },
      modal: {
        failedInstallStep: 'Failed to verify/install package',
        fileError: '{{filename}} is not a valid Makito {{product}} Encoder package',
        reboot: 'Please reboot to complete the update.',
        rebootLater: 'Reboot Later',
        title: 'Update Software',
        uploadHai: 'Upload a .hai file',
        uploadNotice: {
          willStop: 'All active encoders will be stopped temporarily during the upload and verification process',
          stopping: 'Stopping active encoders.',
        },
        uploadingTitle: {
          step1: 'Step 1 of 3: Uploading {{fileName}}',
          step2: 'Step 2 of 3: Verifying {{fileName}} file',
          step3: 'Step 3 of 3: Syncing file system',
          step4: 'It looks like there was an issue with {{fileName}}.',
        },
        uploadingSubTitle: {
          step1: 'Please reboot to complete the update.',
          step2: 'This will take a few minutes.',
          step3: 'This will take a minute.',
        },
        uploadCompleted: '{{fileName}} package is ready!',
      },
      cancelModal: {
        headline: 'Cancel Update?',
        bodyText: 'Canceling will no longer install {{fileName}} on reboot.',
        keepUpdate: 'KEEP UPDATE',
        cancelUpdate: 'CANCEL UPDATE',
      },
    },
    network: {
      title: 'Network',
      section: {
        general: 'General',
        interface: 'Interface',
        ethernet: 'Ethernet',
        dns: 'DNS',
      },
      addressing: {
        dhcp: 'DHCP',
        static: 'Static',
      },
      ipv6Addressing: {
        auto: 'Automatic',
        dhcp: 'Automatic (DHCP)',
        static: 'Static',
      },
      link: {
        manual: 'Manual',
        auto: 'Automatic',
      },
      speed: {
        any: 'Any',
        '10': '10 Mpbs',
        '100': '100 Mbps',
        '1000': '1000 Mbps',
      },
      duplex: {
        full: 'Full',
        half: 'Half',
      },
      dnsPrecedence: {
        ipv4: 'IPv4',
        ipv6: 'IPv6',
      },
      form: {
        // TODO rename some to match the model name so rest api, form and translation use the same name and can be easily followed
        addressing: 'Addressing',
        alternateDns: 'Alternate DNS Server Address',
        bandwidth: 'Total TX Bandwidth',
        bandwidthExplain: 'kbps',
        currentSpeed: 'Current Speed',
        currentSpeedValue: '{{value}} Mbps',
        dhcpVendor: 'DHCP Vendor Class ID',
        dnsPrecedence: 'DNS Precedence',
        domain: 'Domain',
        duplex: 'Duplex',
        ipv6PrivacyExtension: 'Enable Privacy Extensions',
        gateway: 'Gateway',
        globalIpv6Address: 'Global IPv6 Address',
        hostname: 'Hostname',
        ipAddress: 'IP Address',
        ipv4: 'IPv4',
        ipv6: 'IPv6',
        ipv6AddressList: 'Global IPv6 Address',
        link: 'Link',
        linklocal: 'Assign Link-Local Address When DHCP Fails',
        ipv6LinkLocal: 'Link-Local IPv6 Address',
        macAddress: 'MAC Address',
        mdns: 'Enable mDNS',
        mDnsName: 'mDNS Identifier',
        netmask: 'Netmask',
        obtainDns: 'Obtain DNS Settings Automatically',
        primaryDns: 'Primary DNS Server Address',
        speed: 'Speed',
        subnetPrefixLength: 'Subnet Prefix Length',
      },
      mdnsModal: {
        title: 'Warning',
        body: 'With DHCP enabled, you may wish to consider also enabling mDNS to allow this encoder to be discovered by element management systems and other mDNS compliant applications. Be sure to include a unique name for this device in the "mDNS Identifier" field.',
        cancelButtonTitle: 'CLOSE',
        dontShowAgainButtonTitle: "DON'T SHOW AGAIN",
      },
      options: {
        all: 'All',
        eth0: 'eth0',
        eth1: 'eth1',
      },
    },
    dateTime: {
      title: 'Date and Time',
      notifications: {
        ntpTestSuccess: 'Valid NTP server',
        success: 'Success updating Date & Time',
        successPtp: 'Success updating PTP',
        error: 'Failed to update Date & Time',
      },
      section: {
        timezone: {
          title: 'TIMEZONE',
          timezoneLocale: 'Time Zone',
          currentTime: 'Current Time',
        },
        server: {
          title: 'TIME SERVER',
          ntpServer: 'NTP Server',
          ntpServerPlaceholder: 'Add NTP Server',
          useNtpServer: 'Use NTP',
          manualDateTime: 'Manually Set Date & Time',
        },
        ptp: {
          announcementInterval: 'Announcement Interval',
          announcementTimeout: 'Announcement Timeout',
          clockState: 'Clock State',
          clockId: 'Clock ID',
          delayMechanism: 'Delay Mechanism',
          domainNumber: 'Domain Number',
          syncInterval: 'Synchronization Interval',
          title: 'PTP',
          enums: {
            announcementInterval: {
              [PTP_ANNOUNCEMENT_INTERVAL.ANNOUNCE_INTERVAL_125_MSEC]: '0.125 sec',
              [PTP_ANNOUNCEMENT_INTERVAL.ANNOUNCE_INTERVAL_250_MSEC]: '0.25 sec',
              [PTP_ANNOUNCEMENT_INTERVAL.ANNOUNCE_INTERVAL_500_MSEC]: '0.5 sec',
              [PTP_ANNOUNCEMENT_INTERVAL.ANNOUNCE_INTERVAL_1_SEC]: '1 sec',
              [PTP_ANNOUNCEMENT_INTERVAL.ANNOUNCE_INTERVAL_2_SEC]: '2 sec',
            },
            delayMechanism: {
              [PTP_DELAY_MECHANISM.AUTO]: 'Auto',
              [PTP_DELAY_MECHANISM.E2E]: 'E2E',
              [PTP_DELAY_MECHANISM.P2P]: 'P2P',
            },
            syncInterval: {
              [PTP_SYNC_INTERVAL.SYNC_INTERVAL_7812500_NSEC]: '0.0078125 sec',
              [PTP_SYNC_INTERVAL.SYNC_INTERVAL_15625_USEC]: '0.015625 sec',
              [PTP_SYNC_INTERVAL.SYNC_INTERVAL_31250_USEC]: '0.03125 sec',
              [PTP_SYNC_INTERVAL.SYNC_INTERVAL_62500_USEC]: '0.0625 sec',
              [PTP_SYNC_INTERVAL.SYNC_INTERVAL_125_MSEC]: '0.125 sec',
              [PTP_SYNC_INTERVAL.SYNC_INTERVAL_250_MSEC]: '0.25 sec',
              [PTP_SYNC_INTERVAL.SYNC_INTERVAL_500_MSEC]: '0.5 sec',
              [PTP_SYNC_INTERVAL.SYNC_INTERVAL_1_SEC]: '1 sec',
              [PTP_SYNC_INTERVAL.SYNC_INTERVAL_2_SEC]: '2 sec',
            },
          },
        },
        statistics: {
          title: 'NTP Statistics',
          tracking: 'Tracking',
          sources: 'Sources',
          sourceStats: 'Source Statistics',
        },
      },
    },
    services: {
      title: 'Services',
      confirmHttpOffModal: {
        title: 'Warning',
        bodyText:
          'Once you stop the HTTP service you will no longer be able to access this device via its web interface. Web access can only be restored using the command line console. Before continuing, verify that you have SSH (or Telnet) access to this device.',
        proceedButton: 'STOP HTTP',
      },
      nmos: {
        button: 'APPLY',
        title: 'NMOS SERVICES',
        is04title: 'IS-04 Registry',
        discoveryMode: 'Discovery Mode',
        discoveryOptions: {
          automatic: 'Automatic',
          manual: 'Manual',
        },
        enums: {},
        field: {
          is09: 'IS-09 System Parameters',
          nodePort: 'Node Port',
          nodePortHint: '1 - 65535',
          is04Address: 'IP Address',
          is04Port: 'Port',
          is04PortHint: '1 - 65535',
          is09Address: 'IP Address',
          is09Port: 'Port',
          is09PortHint: '1 - 65535',
        },
        notifications: {
          invalidIpAddressErrorMsg: 'Invalid IPv4 address',
        },
        successMsg: 'Success configuring NMOS',
        errorMsg: 'Failed to configure NMOS',
      },
      section: {
        general: {
          ems: 'EMS',
          http: 'HTTP',
          interface: 'Interface',
          nmos: 'NMOS',
          onvif: 'ONVIF',
          passthrough: 'Serial Pass-Through',
          preview: 'Thumbnail Preview',
          rtsp: 'RTSP',
          snmp: 'SNMP',
          ssh: 'SSH',
          telnet: 'Telnet',
          title: 'General',
        },
        ems: {
          title: 'EMS / Cloud Services',
          passcode: {
            label: 'Passcode',
            labelExplain: 'Copy from Haivision EMS or Cloud Services',
            validationName: 'Passcode',
          },
          connectionStatus: {
            label: 'Connection Status',
          },
          hostname: {
            label: 'Address',
            validationName: 'Address',
          },
          port: {
            label: 'Port',
            validationName: 'Port',
          },
          keepAlive: {
            label: 'Keep Alive (Seconds)',
            validationName: 'Keep Alive',
          },
          button: {
            pair: 'PAIR',
            unpair: 'UNPAIR',
            cancelPairing: 'CANCEL PAIRING',
          },
        },
        onvif: {
          title: 'ONVIF',
          location: 'Location(s)',
          discovery: 'WS-Discovery',
          reboot: 'The system must be restarted for changes to take effect.',
        },
        passthrough: {
          title: 'Serial Pass-Through',
          port: 'Port',
          portExplain: '1 - 65535',
        },
        preview: {
          title: 'Thumbnail Preview',
          interval: 'Interval (Seconds)',
          intervalExplain: '1 - 60',
        },
      },
      notifications: {
        analyticsDisableSuccessMsg: 'Product analytics disabled',
        analyticsEnableSuccessMsg: 'Product analytics enabled',
        analyticsErrorMsg: 'Product analytics could not be changed',
        disableErrorMsg: '{{service}} service could not be disabled',
        disableSuccessMsg: '{{service}} service disabled',
        enableErrorMsg: '{{service}} service could not be enabled',
        enableSuccessMsg: '{{service}} service enabled',
        nicErrorMsg: 'Network interface could not be chnaged',
        nicSuccessMsg: 'Network interface changed',
        onvifErrorMsg: 'ONVIF parameters could not be changed',
        onvifSuccessMsg: 'ONVIF parameters changed',
        passthroughErrorMsg: 'Serial Pass-Through parameters could not be changed',
        passthroughSuccessMsg: 'Serial Pass-Through parameters changed',
        previewErrorMsg: 'Thumbnail Preview parameters could not be changed',
        previewSuccessMsg: 'Thumbnail Preview parameters changed',
      },
    },
    licensing: {
      title: 'Licensing',
      addFirst: 'No Licenses to Display',
      licenseFeatures: 'License Features',
      sectionTitle: 'INSTALLED LICENSES',
      modal: {
        delete: {
          title: 'Delete this license?',
          title_plural: 'Delete {{count}} licenses?',
          bodyText: 'Deleting licenses can disable important features needed for this device to function properly.',
        },
        import: {
          title: 'Install a License',
        },
      },
      notifications: {
        deleteErrorMsg: '{{count}} license could not be deleted',
        deleteErrorMsg_plural: '{{count}} licenses could not be deleted',
        installErrorMsg: "License '{{name}}' could not be installed",
      },
    },
    comport: {
      title: 'COM Port',
      general: 'General',
      form: {
        baudRate: 'Baud Rate',
        dataBits: 'Data Bits',
        flowControl: 'Flow Control',
        mode: 'Mode',
        parity: 'Parity',
        standard: 'Standard',
        stopBits: 'Stop Bits',
      },
      mode: {
        management: 'Management',
        metadata: 'Metadata',
        passThrough: 'Pass-Through',
      },
      notifications: {
        changeSuccessMsg: 'COM Port updated',
        changeErrorMsg: 'COM Port could not be updated',
      },
    },
  },
};
